import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { Card, CardHeader, CardContent, CardActions, Avatar, IconButton, Button, Typography } from "@material-ui/core";
import moment from "moment";
import API from "../../actions";
import queryString from "query-string";
import DeleteIcon from "@material-ui/icons/Delete";
import CloseIcon from "@material-ui/icons/Close";
import InvoiceSettings from "../Invoice/InvoiceSettings.js";

const useStyles = makeStyles(theme => ({
    root: {
        width: "100%",
        height: "100%",
        position: "inherit",
        zIndex: 2,
        display: "flex",
        flexDirection: "column"
    }
}));

export default props => {
    const classes = useStyles();
    const history = useHistory();
    const [width, setWidth] = useState(window.innerWidth);

    const journalClick = async () => {
        if (props.even.journalId) {
            history.push(
                "Klientdata?" +
                    queryString.stringify({
                        id: props.even.clientId,
                        journalId: props.even.journalId
                    })
            );
            return;
        }

        const journal = {
            treatmentId: props.even.treatmentId,
            clientId: props.even.clientId,
            therapistId: props.even.therapistId,
            bookingId: props.even.bookingId
        };
        const temp = await API.addJournal(journal);

        history.push(
            "Klientdata?" +
                queryString.stringify({
                    id: props.even.clientId,
                    journalId: temp.id
                })
        );
    };
    const stamJournalClick = () => {
        history.push(
            "Klientdata?" +
                queryString.stringify({
                    id: props.even.clientId,
                    journalId: "stamjournal"
                })
        );
    };

    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    });

    return (
        <Card className={classes.root}>
            <CardHeader
                avatar={
                    <Avatar aria-label="recipe" style={{ backgroundColor: props.even.backgroundColor }}>
                        B
                    </Avatar>
                }
                action={
                    <IconButton aria-label="settings" data-testid="closeBookingCard" onClick={props.close}>
                        <CloseIcon />
                    </IconButton>
                }
                title={props.even.orgTitle}
                subheader={
                    props.even.end
                        ? moment(props.even.start).format("DD/MM/YYYY HH:mm:ss") +
                          " - " +
                          moment(props.even.end).format("HH:mm:ss") /*+ ' ' + props.even.dkTime */
                        : ""
                }
            />

            <CardContent style={{ flex: 1 }}>
                <Typography variant="body1" color="textPrimary" component="p">
                    Behandling
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                    {props.even.description}
                </Typography>
                <br />
                <Typography variant="body1" color="textPrimary" component="p">
                    Årsag til henvendelse
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                    {props.even.reason}
                </Typography>
            </CardContent>
            {width > 800 ? (
                <CardActions disableSpacing style={{ marginTop: "auto" }}>
                    <Button
                        variant="contained"
                        color="primary"
                        style={{
                            backgroundColor:
                                props.therapist.colors != null ? JSON.parse(props.therapist.colors)[1] : "",
                            color: "#fff",
                            marginRight: "10px",
                            height: "100%"
                        }}
                        onClick={() => props.handleEditBooking(props.even)}>
                        Rediger reservation
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        style={{
                            backgroundColor:
                                props.therapist.colors != null ? JSON.parse(props.therapist.colors)[1] : "",
                            color: "#fff",
                            marginRight: "10px",
                            height: "100%"
                        }}
                        onClick={() => (props.even.firstBooking ? stamJournalClick() : journalClick())}>
                        {props.even.firstBooking ? "Stamjournal og Stamdata" : "Journal"}
                    </Button>
                    <div>
                        <InvoiceSettings booking={props.booking} />
                    </div>
                    <Button
                        variant="contained"
                        color="secondary"
                        startIcon={<DeleteIcon />}
                        style={{ marginLeft: "auto", color: "#fff", height: "100%" }}
                        onClick={() => {
                            if (!window.confirm("Er du sikker?")) return;

                            API.deleteBooking(props.even.bookingId);
                            props.close();
                        }}>
                        Slet Booking
                    </Button>
                </CardActions>
            ) : (
                <CardActions disableSpacing style={{ marginTop: "auto", flexDirection: "column" }}>
                    <Button
                        variant="contained"
                        color="primary"
                        style={{
                            backgroundColor:
                                props.therapist.colors != null ? JSON.parse(props.therapist.colors)[1] : "",
                            color: "#fff",
                            marginRight: "10px",
                            height: "100%"
                        }}
                        onClick={() => props.handleEditBooking(props.even)}>
                        Rediger reservation
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        style={{
                            backgroundColor:
                                props.therapist.colors != null ? JSON.parse(props.therapist.colors)[1] : "",
                            color: "#fff",
                            width: "100%"
                        }}
                        onClick={() => (props.stamJournal ? stamJournalClick() : journalClick())}>
                        {props.stamJournal ? "Stamjournal og Stamdata" : "Journal"}
                    </Button>
                    <div style={{ width: "100%", marginTop: "5px", marginBottom: "5px" }}>
                        <InvoiceSettings booking={props.booking} />
                    </div>
                    <Button
                        variant="contained"
                        color="secondary"
                        startIcon={<DeleteIcon />}
                        style={{ marginLeft: "auto", color: "#fff", width: "100%" }}
                        onClick={() => {
                            if (!window.confirm("Er du sikker?")) return;

                            API.deleteBooking(props.even.bookingId);
                            props.close();
                        }}>
                        Slet Booking
                    </Button>
                </CardActions>
            )}
        </Card>
    );
};
